<template>
  <div class="lp-position">
    <div
        v-for="group in groups"
        :key="group.name"
        class="lp-position__group">
      <button
          v-tooltip="button.tooltip"
          v-for="button in group.buttons"
          :key="button.value"
          :class="{ 'is-active': isActive(group.name, button) }"
          :disabled="disabled"
          :aria-label="button.tooltip"
          type="button"
          class="lp-position__btn"
          @click="$emit('align', button.value)">
        <icon :name="button.icon"/>
      </button>
    </div>
  </div>
</template>

<script>
const GROUPS = [
  {
    name:    'horizontal',
    buttons: [
      {
        value:   'left',
        state:   'left',
        icon:    'alignleft',
        tooltip: 'Left',
      },
      {
        value:   'center',
        state:   'center',
        icon:    'aligncenter',
        tooltip: 'Center',
      },
      {
        value:   'right',
        state:   'right',
        icon:    'alignright',
        tooltip: 'Right',
      },
    ],
  },
  {
    name:    'vertical',
    buttons: [
      {
        value:   'top',
        state:   'top',
        icon:    'aligntop',
        tooltip: 'Top',
      },
      {
        value:   'middle',
        state:   'center',
        icon:    'alignmiddle',
        tooltip: 'Middle',
      },
      {
        value:   'bottom',
        state:   'bottom',
        icon:    'alignbottom',
        tooltip: 'Align Bottom',
      },
    ],
  },
];

export default {
  name:  'PositionControls',
  props: {
    horizontal: { type: String, default: null },
    vertical:   { type: String, default: null },
    disabled:   { type: Boolean, default: false },
  },
  data() {
    return { groups: GROUPS };
  },
  methods: {
    isActive(groupName, button) {
      const current = groupName === 'horizontal' ? this.horizontal : this.vertical;
      // getObjectCanvasAlignment reports vertical middle as 'center'
      return !!current && (current === button.state || current === button.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-position {
  display: flex;
  gap: 8px;
}

.lp-position__group {
  display: flex;
  flex: 1 1 0;
  gap: 2px;
  min-width: 0;
  padding: 3px;
  border-radius: 10px;
  background: $lp-fill;
}

.lp-position__btn {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  height: 26px;
  min-width: 0;
  padding: 0 6px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #3d4350;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: rgba($white, 0.7);
  }

  &.is-active {
    background: $white;
    color: #0b57c2;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1), 0 0 0 1px #e7e9ed;

    ::v-deep svg {
      color: #0b57c2;
    }
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ::v-deep .icon {
    min-width: 0;
    min-height: 0;
    color: inherit;
  }

  ::v-deep svg {
    display: block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}
</style>
